import UserActionTypes from './user.types';
import Cookies from 'js-cookie';

export const setUser = user => {
	// localStorage.setItem('currentUser', JSON.stringify(user));
	Cookies.set('currentUser', JSON.stringify(user), {
		sameSite: 'strict'
		// expires: 5 / (24 * 60 * 60) // 5 secondas
	});

	return {
		type: UserActionTypes.SET_USER,
		payload: user
	};
};

export const removeUser = () => {
	// localStorage.removeItem('currentUser');
	Cookies.remove('currentUser');
	return {
		type: UserActionTypes.REMOVE_USER
	};
};
